/**
 * Stats section - matches design-4 exactly
 * Cream background with rounded corners, large serif stats
 */
export function StatsSection() {
  const stats = [
    { value: "92%", label: "Of customers get better rates through us than going direct to banks" },
    { value: "70+", label: "Lenders in our panel including all major banks" },
    { value: "$500M+", label: "In home loans settled for Australian families" },
    { value: "4.9★", label: "Average rating from hundreds of happy clients" },
  ];

  return (
    <section className="px-4 py-4">
      <div className="bg-cream rounded-[2.5rem] py-16 md:py-24 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <p className="section-label mb-6">The Numbers</p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl italic max-w-3xl mx-auto leading-tight">
              Australia's trusted mortgage broker helping families find their perfect home loan
            </h2>

            {/* Rating Badge */}
            <div className="mt-8">
              <span className="rating-badge">
                <span className="text-amber-500">★★★★★</span>
                4.9/5 client rating
              </span>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-12">
            {stats.map((stat, index) => (
              <div key={index} className="text-center px-2">
                <div className="stat-number text-foreground whitespace-nowrap">{stat.value}</div>
                <p className="mt-2 sm:mt-3 text-xs sm:text-sm text-muted-foreground max-w-[180px] sm:max-w-[200px] mx-auto">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
